<template>
    <div id="webpages">
        <h4>Páginas web</h4>
        <span>Página para el <br><a target="_blank" class="link-portfolio" href="https://cmuc.ar/">Colegio Mayor Universitario de Córdoba</a> </span>

    </div>
</template>

<script>
export default {
        name: "Webpages",
}
</script>

<style>
#webpages{
    background: #F9B256;
}
</style>